import React, { Component, Fragment } from 'react'
import { Query, Mutation } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { SELECTED_BRANCH } from '../../constants'
import { SELF_QUERY } from '../../queries'
import { SEND_CONTACT } from '../../mutations'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import Hero from '../../components/Hero/'
import Breadcrumb from '../../components/Breadcrumb/'
import EmployeeCTA from '../../components/EmployeeCTA/'
import Loader from '../../components/Loader/'
import Error from '../../components/Error/'
import Form from '../../components/Form/'

import { Container, FlexContainer } from '../../styles/defaults'
import { MiniContainer, ContentContainer, Content } from './styles'

import hero from '../../assets/hero/contact/hero.jpg'
import employee from '../../assets/cta/employee.png'

import helpers from '../../helpers'

class Contact extends Component {
  render() {
    return (
      <Fragment>
        <Hero small={hero} medium={hero} large={hero} retina={hero} title="Contact" />
        <Breadcrumb title="Contact" />
        <Query query={SELF_QUERY}>
          {({ loading, error, data }) => {
            if (loading) return <Loader from="25%" to="100%" fixed />
            if (error) return <Error error="de gebruikersgegevens" />
            const { self } = data
            let submitError = self.permissions.includes('REPORT_ERROR') || self.role === 'MANAGER'

            let contactFormFields = [
              {
                name: 'to',
                label: 'Afdeling',
                value: process.env.REACT_APP_HOST_ENV === 'production' ? 'info@kaarskoffie.nl' : 'teun@bureaubright.nl',
                type: 'select',
                options: [{ value: process.env.REACT_APP_HOST_ENV === 'production' ? 'info@kaarskoffie.nl' : 'teun@bureaubright.nl', label: 'Algemeen' }, { value: process.env.REACT_APP_HOST_ENV === 'production' ? 'bestellen@kaarskoffie.nl' : 'teun@bureaubright.nl', label: 'Bestellen' }, { value: process.env.REACT_APP_HOST_ENV === 'production' ? 'administratie@kaarskoffie.nl' : 'teun@bureaubright.nl', label: 'Administratie' }]
              },
              { name: 'message', label: 'Uw vraag of opmerking*', value: '', type: 'textarea', required: 'required' }
            ]

            const selectedBranch = self.branches.find(
              branch =>
                (branch.id = window.localStorage.getItem(SELECTED_BRANCH)
                  ? window.localStorage.getItem(SELECTED_BRANCH)
                  : window.sessionStorage.getItem(SELECTED_BRANCH))
            )
            
            self.insertion = helpers.findInsertion(self.insertion)
            let fullName = self.firstName + ' ' + (self.insertion !== null ? self.insertion + ' ' : '') + self.lastName
            let submitted = false
            if (submitError) {
              return (
                <FlexContainer small full mt mb>
                  <MiniContainer>
                    <Mutation mutation={SEND_CONTACT}>
                      {(sendContactForm, { data, loading, error }) => (
                        <Form
                          fields={contactFormFields}
                          submitText="Verzenden"
                          userId={this.props.match.params.id}
                          loading={loading}
                          error={error}
                          submitted={submitted}
                          onSubmitForm={async data => {
                            sendContactForm({
                              variables: {
                                data: {
                                  to: data.variables.data.to,
                                  user: fullName,
                                  userId: self.id,
                                  branch: selectedBranch.name,
                                  branchId: selectedBranch.id,
                                  message: data.variables.data.message
                                }
                              }
                            })
                              .then(() => {
                                this.props.history.push('/contact/bedankt')
                              })
                              .catch(e => {
                                console.error(e)
                              })
                          }}
                          data={data}
                          succesMessage={'Uw bericht is verzonden'}
                        />
                      )}
                    </Mutation>
                  </MiniContainer>
                  <ContentContainer>
                    <Content>
                      <p>
                        Service to the boon, dat is onze drive. Daarom staan wij altijd voor u klaar. Heeft u een vraag, service nodig of wilt u meer producten? Vul dan het formulier in en wij reageren binnen één werkdag.
                      </p>
                    </Content>
                    <EmployeeCTA
                      size={'medium'}
                      content={{
                        title: 'Liever direct reactie?',
                        subtitle: 'Wij staan u graag te woord.',
                        employee: true,
                        image: employee,
                        link: {
                          content: 'Bel ons',
                          url: 'tel:0182-308000',
                          target: ''
                        }
                      }}
                    />
                  </ContentContainer>
                </FlexContainer>
              )
            } else {
              return (
                <Container mt mb>
                  Onvoldoende rechten om een storing te melden
                </Container>
              )
            }
          }}
        </Query>
      </Fragment>
    )
  }
}

export default withRouter(withHeaderFooter(Contact))



// WEBPACK FOOTER //
// ./src/views/Contact/index.js